import { Stack, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	ArtFormInput,
	ArtFormOutput,
} from "web_myplann/Portfolio/Forms/ArtForm/artFormSchema";
import { FlatRowFormDatePicker } from "web_myplann/Shared/Components/FlatRow/FlatRowFormDatePicker";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { FlatRowFormSwitch } from "web_myplann/Shared/Components/FlatRow/FlatRowFormSwitch";
import { FlatRowFormTextarea } from "web_myplann/Shared/Components/FlatRow/FlatRowFormTextarea";
import { DateView } from "web_myplann/Shared/Types/DateView";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

type ArtFormFieldsProps = {
	control: Control<ArtFormInput, unknown, ArtFormOutput>;
};

export const ArtFormFields = ({ control }: ArtFormFieldsProps) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<Typography variant="sectionLabel">
				{t(Resources.Portfolio.AddArt.Sections.basicInfo)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<FlatRowFormInput
					control={control}
					name="propertyType"
					label={t(Resources.Portfolio.AddArt.Fields.itemTitle)}
					placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				/>
				<FlatRowFormInput
					control={control}
					name="customDisposition"
					label={t(Resources.Portfolio.AddArt.Fields.shortDescription)}
					placeholder={t(Resources.Portfolio.AddShared.Placeholders.optional)}
				/>
				<FlatRowFormInput
					control={control}
					name="value"
					type="float"
					label={t(Resources.Portfolio.AddArt.Fields.value)}
					placeholder={t(Resources.Portfolio.AddShared.Placeholders.optional)}
					suffix="Kč"
				/>
				<FlatRowFormDatePicker
					control={control}
					name="purchaseDate"
					label={t(Resources.Portfolio.AddArt.Fields.purchaseDate)}
					views={[DateView.Year, DateView.Month, DateView.Day]}
					displayFormat={DateFormat.Display}
					isLast
				/>
			</Stack>

			<Typography variant="sectionLabel">
				{t(Resources.Portfolio.AddArt.Sections.investment)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<FlatRowFormSwitch
					control={control}
					name="forInvestments"
					redesigned
					label={t(Resources.Portfolio.AddArt.Fields.forInvestments)}
					isLast
				/>
			</Stack>

			<Typography variant="sectionLabel">
				{t(Resources.Portfolio.AddArt.Sections.description)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<FlatRowFormTextarea
					control={control}
					name="description"
					label={t(Resources.Portfolio.AddArt.Fields.description)}
					placeholder={t(Resources.Portfolio.AddShared.Placeholders.optional)}
					rows={1}
					isLast
				/>
			</Stack>
		</>
	);
};
